import React from "react"
import * as tracking from "../../helpers/tracking"
import * as cookieNames from "../../constants/Cookies"
import * as cookieHelper from "../../../helpers/cookie"
import { Cookies } from "react-cookie"

const MapMarkerEpi = (props) => {
  const {
    carParkName,
    useIcon,
    markerIcon,
    memberPrice,
    onlinePrice,
    campaignText,
    parkingDistance,
    parkingDistanceIcon,
    parkingCondition,
    parkingConditionIcon,
    buttonText,
    panningMapX,
    panningMapY,
    isCenter,
    title,
    hasCampaign,
    language,
    textKeys,
    setBookingStarterData,
  } = props

  const handlePinClick = (e) => {
    const outerWrapper = e.currentTarget.closest("div.js--panning-map-interactive > div")
    if (!outerWrapper) return
    const titleEl = outerWrapper.querySelector(".title")
    const productName = titleEl?.innerText || "N/A"
    tracking.trackParkingEngagementClick("parking - map", `pin - click - ${productName}`)
  }

  const handleMarkerButtonClick = (e, carParkName) => {
    e.stopPropagation()

    // Find product name
    const outerWrapper = e.currentTarget.closest("div.js--panning-map-interactive > div")
    const productNameEl = outerWrapper?.querySelector(".title")
    const productName = productNameEl?.innerText || "N/A"

    // Track "booking" click
    tracking.trackParkingEngagementClick("parking - map", `gå til booking - click - ${productName}`)

    // dataLayer push for booking starter modal
    const cookies = new Cookies()
    const userId = cookies.get(cookieNames.IDP_USER_ID)
    const locale = language || "en"

    const bookingStarterData = {
      pageBusinessunit: "parking",
      virtualPath: tracking.getVirtualPath("/virtual/(|en/|sv/)parkering/dates", locale),
      event: "track-vp",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) bookingStarterData.userId = userId
    window.dataLayer.push(bookingStarterData)

    setBookingStarterData()
  }

  const getMarkerClass = (marker) => {
    const { hasCampaign, productAdvantageStyle, sortingFilters = "" } = marker
    let base = "map-marker map-marker--parking"
    if (hasCampaign) {
      base += " map-marker--campaign"
    } else if (productAdvantageStyle) {
      base += ` map-marker--${productAdvantageStyle}`
    }
    if (sortingFilters) {
      const filterClasses = sortingFilters.replace(",", " ")
      base += ` ${filterClasses}`
    }
    return base
  }

  const markerClass = getMarkerClass(props)
  const positionStyle = `left:${panningMapX}%;top:${panningMapY}%`
  const showMember = memberPrice && parseInt(memberPrice) > 0
  const mainPrice = showMember ? memberPrice : onlinePrice

  return (
    <div
      className={markerClass}
      data-positionstyle={positionStyle}
      data-positionx={panningMapX}
      data-positiony={panningMapY}
      data-center={isCenter ? "true" : "false"}
      onClick={handlePinClick}
    >
      <div className="bubble">
        {useIcon ? (
          <span className="icon" style={{ right: 0 }}>
            <svg className="svg-icon svg-icon--keypickup">
              <use xlinkHref={`/dist/svg/symbols.svg#svg-${markerIcon}`} />
            </svg>
          </span>
        ) : (
          <span>{carParkName}</span>
        )}
        <strong>&times;</strong>
      </div>

      <div className="label">
        <span className="label__inner">
          {textKeys?.fromLabel}{" "}
          <strong>
            {mainPrice} {textKeys?.currencyType}
          </strong>
          /{textKeys?.paymentInterval}
        </span>
      </div>

      <div className="content">
        <div className="content__inner">
          {hasCampaign && (
            <span className="angled-ribbon map-marker--parking map-marker--direct">
              <span className="angled-ribbon__inner">{campaignText}</span>
            </span>
          )}

          <div className="details">
            <div className="title">
              <h4>
                {title} <em>{carParkName}</em>
              </h4>
            </div>
            <div className="features">
              <p>
                <svg className="svg-icon svg-icon--passenger">
                  <use xlinkHref={`/dist/svg/symbols.svg#svg-${parkingDistanceIcon}`} />
                </svg>
                <span>{parkingDistance}</span>
              </p>
              <p>
                <svg className="svg-icon svg-icon--sun">
                  <use xlinkHref={`/dist/svg/symbols.svg#svg-${parkingConditionIcon}`} />
                </svg>
                <span>{parkingCondition}</span>
              </p>
            </div>
          </div>

          <div className="price">
            <div className="price__inner">
              {showMember ? (
                <>
                  <h6>{textKeys?.memberLabel}</h6>
                  <h5>
                    {textKeys?.fromLabel}{" "}
                    <strong>
                      {memberPrice} {textKeys?.currencyType}
                    </strong>{" "}
                    /{textKeys?.paymentInterval}
                  </h5>
                  <p>
                    {textKeys?.nonMemberLabel}: {onlinePrice} {textKeys?.currencyType}
                  </p>
                </>
              ) : (
                <>
                  <h6>&nbsp;</h6>
                  <h5>
                    {textKeys?.fromLabel}{" "}
                    <strong>
                      {onlinePrice} {textKeys?.currencyType}
                    </strong>{" "}
                    /{textKeys?.paymentInterval}
                  </h5>
                </>
              )}
            </div>
            <a
              className="button button--small button--general js-map-marker-parking-button"
              data-template="parkingTimePickerModalTemplate"
              onClick={(e) => handleMarkerButtonClick(e, carParkName)}
            >
              <span className="text">{buttonText}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MapMarkerEpi
